export const settings = {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  ymCounterId: process.env.YM_COUNTER_ID
}